import Header from '../Header/Header';
import Footer from "../Footer/Footer";
import icon02 from "../../../screenassets/images/cta/02.png";
import { useState } from 'react';
import { ToastContainer, toast } from "react-toastify";
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { IoEyeOutline, IoEyeOffOutline } from "react-icons/io5";


export default function OtpVerify() {

    const [otp, setOtp] = useState(["", "", "", "", "", ""]);
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');

    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const togglePassword = () => setShowPassword(!showPassword);

    const navigate = useNavigate();
    const location = useLocation();

    const receivedData = location.state;
    const email = receivedData?.email;

    const handleChange = (value, index) => {
        if (/^[0-9]?$/.test(value)) {
            const newOtp = [...otp];
            newOtp[index] = value;
            setOtp(newOtp);

            // auto move to next input
            if (value && index < 5) {
                document.getElementById(`otp-${index + 1}`).focus();
            }
        }
    };

    function validatePassword(password) {
        const re = /^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z]).{8,}$/;
        return re.test(password);
    };

    const handleSubmit = async (event) => {
        event.preventDefault();

        const numberValue = Number(otp.join(""));

        const otpData = {
            otp: numberValue,
            password: password,
            confirmPassword: confirmPassword,
            email
        };

        if (!validatePassword(password)) {
            toast.info("Password must be at least 8 characters, include uppercase, lowercase, number, and special character!");
            return;
        }
        if (!validatePassword(confirmPassword)) {
            toast.info("Confirm password must be at least 8 characters, include uppercase, lowercase, number, and special character!");
            return;
        }

        if (password !== confirmPassword) {
            toast.error("Password and Confirm Password should be same!");
        }

        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/auth/otpvalidate`, {
                method: "POST",
                mode: 'cors',
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(otpData),
            });

            const data = await response.json();
            console.log("Otpverify response:", data);

            if (data.status === true) {
                toast.success("OTP verified or password reset successfully!");
                navigate('/Signin');
            } else {
                toast.error("Invalid OTP or password. Please try again.");
                navigate("/Otpverify", { state: { email: email } });
            }

            setOtp(["", "", "", "", "", ""]);
            setPassword("");
            setConfirmPassword("");

        } catch (error) {
            console.log("Error during signup:", error);
        }
    };

    return (
        <>
            {/* Header Section */}
            <Header />

            <div className="rts-bread-crumb-area bg_image">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="breadcrumb-inne">
                                <div className="title-area">
                                    <h1 className="bread-title">Otp Verify</h1>
                                    <div className="inner-wrapper">
                                        <Link to="/">Home</Link>/
                                        <Link to="#" className="active">Otp Verify</Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>



            {/* Toast container */}
            <ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} />

            {/* Form Section */}
            <div className="rts-reset-area rts-section-gap">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="single-form-s-wrapper text-start ptb--120 ptb_sm--50">
                                <div className="head">
                                    <h5 className="title">Verify Your Otp</h5>
                                    <p className="mb--20">
                                        Strong passwords include numbers, letters, and punctuation
                                        marks.
                                    </p>
                                </div>
                                <div className="body">
                                    <form onSubmit={(event) => { handleSubmit(event) }}>

                                        <div className="container">
                                            <div className="row justify-content-center otp-inputs">
                                                {otp.map((digit, index) => (
                                                    <div className="col-2 col-sm-1 p-1 d-flex justify-content-center">
                                                        <input type="text" key={index} id={`otp-${index}`} name="otp" maxLength="1" value={digit} onChange={(event) => handleChange(event.target.value, index)} className="form-control text-center otp-box" required />
                                                    </div>
                                                ))}
                                            </div>
                                        </div>

                                        <div className="container">

                                            <div className="input-wrapper mt-4">
                                                <input type={showPassword ? "text" : "password"} value={password} onChange={(event) => { setPassword(event.target.value) }} placeholder="Password" required className="pr-10 border-0" Style="border: none !important" />

                                                {/* Toggle button */}
                                                <button type="button" onClick={(event) => togglePassword(event)} className="passwordShow">
                                                    {showPassword ? <IoEyeOffOutline /> : <IoEyeOutline />}
                                                </button>
                                            </div>


                                            <div className="input-wrapper mt-4">
                                                <input type={showConfirmPassword ? "text" : "password"} value={confirmPassword} onChange={(event) => { setConfirmPassword(event.target.value) }} placeholder="Confirm Password" required className="pr-10" Style="border: none !important" />

                                                {/* Toggle button */}
                                                <button type="button" onClick={() => setShowConfirmPassword(!showConfirmPassword)} className="passwordShow" >
                                                    {showConfirmPassword ? <IoEyeOffOutline /> : <IoEyeOutline />}
                                                </button>
                                            </div>


                                            <button type="submit" className="rts-btn btn-primary text-white">
                                                Reset Password
                                            </button>
                                        </div>
                                        <p>
                                            <Link to="/signin"><i className="fa-solid fa-arrow-left"></i> Back to Login</Link>
                                        </p>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            <div className="rts-cta-area rts-section-gapBottom bg_faq">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="cta-main-wrapper bg_image">
                                <div className="left">
                                    <h3 className="title">
                                        All set to level up <br />
                                        your content game?
                                    </h3>
                                    <Link to="/about" className="rts-btn btn-primary text-white">Get Started Now</Link>
                                </div>
                                <div className="right">
                                    <img src={icon02} alt="cta-area" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            {/* Footer Section */}
            <Footer />

        </>
    )
}
